export default {
  "agentApproval.title": "Agent Approval",
  "agentApproval.thead.index": "#No",
  "agentApproval.thead.applyId": "ApplyId",
  "agentApproval.thead.userno": "Userno",
  "agentApproval.thead.email": "Email",
  "agentApproval.thead.statusDesc": "Status",
  "agentApproval.thead.applyTime": "ApplyTime",
  "agentApproval.thead.action": "Action",
  "agentApproval.tooltip.copyUserNo": "CopyUserNo",
  "agentApproval.tooltip.userDetails": "UserDetails",
};
